import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import {
  ApexChartOptions,
  ApexCharts,
  ApexChartSeriesType,
} from '@/components/common/apex-charts'
import { useIntl } from '@/i18n/hooks/use-intl'

interface ContentDistributionChartProps {
  series: ApexChartSeriesType
  chartOptions: ApexChartOptions
}

const ContentDistributionChart: FunctionComponent<
  ContentDistributionChartProps
> = ({ series, chartOptions }) => {
  const { formatMessage } = useIntl()
  return (
    <>
      <ChartContainer>
        <ApexCharts
          options={chartOptions}
          series={[{ data: series }]}
          type='radar'
        />
      </ChartContainer>
      <ChartUnitInfo>
        {formatMessage({
          id: 'kol:content_distribution_radar_chart_unit',
        })}
      </ChartUnitInfo>
    </>
  )
}

export default ContentDistributionChart

const ChartContainer = styled.div`
  height: 130px;
  width: 100%;
`

const ChartUnitInfo = styled.div`
  text-align: right;
  font-size: 12px;
  margin-top: 8px;
  color: ${({ theme }): string => theme.colors.gray10};
  @media (max-width: 980px) {
    text-align: center;
  }
`
